<template>
  <section>
    <!-- 새하 참석자 추가초대 -->
    <v-card id="meetingInvitation">
      <div class="popup_top dialog-header" style="height: 77px;">
        <div class="popup-title">참석자 추가 초대</div>
      </div>

      <div class="popup_tel_wrap" style="min-width: 680px">
        <div class="member_warp" style="min-height:210px;">
          <div
            class="member-top-area"
            style="width:100%; min-height: 80px; border-bottom: 1px solid #EEEEEE"
          >
            <div class="button_area">
              <button @click="openOrganizationDialog()">조직도</button>
            </div>
          </div>
          <div class="list_info">
            <div
              class="attendees-list-header"
              v-bind:style="{ display: isActive }"
            >
              <div
                style="color: #666;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 150%; /* 21px */
                        letter-spacing: -0.56px;"
              >
                참석자 목록
              </div>
              <button class="delete_all" @click="selectAllDelete()">
                <img
                  style="position: relative; top: 2px; right: 5px;"
                  src="../../src/images/button/btnClose.png"
                />
                전체삭제
              </button>
            </div>
            <div class="con">
              <div class="room">
                <ul
                  class="user_list"
                  style="overflow: auto; height: 170px; max-height: 200px; padding-right: 20px;"
                >
                  <li
                    v-for="(attendee, index) in attendees"
                    v-bind:item="attendee"
                    v-bind:index="index"
                    v-bind:key="attendee.email"
                  >
                    <div v-if="attendee.DEPT_NM" class="detail_member_04">
                      {{ attendee.name }} ({{ attendee.DEPT_NM }})
                    </div>
                    <div v-else-if="!attendee.DEPT_NM" class="detail_member_04">
                      <!-- 이름, 메일, 연락처 다 있는경우 -->
                      <span
                        v-if="attendee.name && attendee.email && attendee.phone"
                        >{{
                          attendee.name +
                            ` (${attendee.email}_${attendee.phone})`
                        }}</span
                      >
                      <!-- 이름, 이메일 있는 경우 -->
                      <span v-else-if="attendee.name && attendee.email">
                        {{ attendee.name + ` (${attendee.email})` }}</span
                      >
                      <!-- 이름, 휴대폰 있는데 이름과 휴대폰이 같을 경우 -->
                      <span
                        v-else-if="
                          attendee.name &&
                            attendee.phone &&
                            attendee.name === attendee.phone
                        "
                      >
                        {{ attendee.phone }}</span
                      >
                      <!-- 이름, 휴대폰 있는데 이름과 휴대폰이 다를 경우 -->
                      <span
                        v-else-if="
                          attendee.name &&
                            attendee.phone &&
                            attendee.name !== attendee.phone
                        "
                      >
                        {{ attendee.name + ` (${attendee.phone})` }}</span
                      >
                      <!-- 메일, 휴대폰 있는 경우  -->
                      <span v-else-if="attendee.email && attendee.phone">
                        {{ attendee.email + ` (${attendee.phone})` }}</span
                      >
                      <!-- 이메일만 있는 경우  -->
                      <span v-else-if="attendee.email">{{
                        attendee.email
                      }}</span>
                      <!-- 휴대폰만 있는 경우 -->
                      <span v-else-if="attendee.phone">{{
                        attendee.phone
                      }}</span>
                    </div>
                    <img
                      src="../../src/images/button/btnClose.png"
                      @click="selectDelete(attendee)"
                    />
                  </li>
                </ul>
              </div>
            </div>
            <!-- //con -->
          </div>
          <!-- //list_info -->
        </div>
      </div>
      <!-- //.popup_tel_wrap -->
      <div class="btnArea" style="display: flex; justify-content: end;">
        <button
          class="dialog-okBtn"
          @click="additionalInvitation(attendees, notice)"
        >
          추가초대
        </button>
      </div>
    </v-card>
    <!-- 즐겨찾기 추가 -->
    <bookmark-create-dialog
      :dialog="bookmarkCreateDialog.dialog"
      :attendees="attendees"
      :closeDialog="closeBookmarkCreateDialog"
    />

    <!-- 엑셀 다운로드 -->
    <excel-create-dialog
      :dialog="excelCreateDialog.dialog"
      :closeDialog="closeExcelUploadDialog"
    />

    <!-- 즐겨찾기 목록 보기 -->
    <bookmark-dialog
      :dialog="bookmarkDialog.dialog"
      :closeDialog="closeBookmarkDialog"
    />

    <!-- 조직도 -->
    <add-organization-chart-dialog
      @createSelectedList="createSelectedList"
      :dialog="organizationChartDialog.dialog"
      :closeDialog="closeOrganizationDialog"
    />

    <!-- 개인주소록 -->
    <personal-address-dialog
      :dialog="personalAddressDialog.dialog"
      :closeDialog="closePersonalAddressDialog"
    />

    <!-- 참석자 등록 -->
    <add-attendee-dialog
      :dialog="addAttendeeDialog.dialog"
      :closeDialog="closeAddAttendeeDialog"
    />
    <!-- 경고 -->
    <alert
      :dialog="alertDialog.dialog"
      :closeDialog="closeAlert"
      :contents="alertDialog.contents"
    ></alert>
  </section>
</template>

<script>
import Util from '@/util';
import Alert from '@/components/popup/Alert';
import MeetingCreate from '@/components/meeting/MeetingCreate';
import BookmarkDialog from '@/components/popup/BookmarkDialog';
import BookmarkCreateDialog from '@/components/popup/BookmarkCreateDialog';
import ExcelCreateDialog from '@/components/popup/ExcelCreateDialog';
import AddOrganizationChartDialog from '@/components/popup/TbOrganizationChartDialog';
import PersonalAddressDialog from '@/components/popup/PersonalAddressDialog';
import AddAttendeeDialog from '@/components/popup/AddAttendeeDialog';
import debounce from 'lodash.debounce';
import base64 from 'base64url';

export default {
  components: {
    MeetingCreate,
    BookmarkDialog,
    BookmarkCreateDialog,
    ExcelCreateDialog,
    AddOrganizationChartDialog,
    PersonalAddressDialog,
    AddAttendeeDialog,
    base64,
    Alert,
  },
  props: ['attendeesInfo', 'noticeInfo'],
  data() {
    return {
      alertDialog: {
        dialog: false,
        contents: '',
      },
      loading: false,
      isHelpActive: 'none',
      isActive: 'none',
      isLayoutActive: 'none',
      organizationChartDialog: {
        dialog: false,
      },
      personalAddressDialog: {
        dialog: false,
      },
      excelCreateDialog: {
        dialog: false,
      },
      bookmarkDialog: {
        dialog: false,
      },
      addAttendeeDialog: {
        dialog: false,
      },
      bookmarkCreateDialog: {
        dialog: false,
      },
      layoutDialog: {
        dialog: false,
      },
      searchName: null,
      isLoading: false,
      search: null,
      friends: [],
      isUpdating: false,
      name: 'Midnight Crew',
      organization: [],
      attendees: [],
      editedAttendees: [],
      notice: {
        email: true,
        kakao: true,
      },
      selected: null,
      searchPeople: null,
      checked: [],
      allSelected: false,
      selectTitle: '전체선택',
      selectedList: [],
      /* 임직원 검색 */
      people: [],
      checkedMember: [],
    };
  },
  computed: {
    attendeesString() {
      let attendees_str = '';
      if (this.attendees.length === 1) {
        attendees_str = `${this.attendees[0].name}`;
      } else if (this.attendees.length > 1) {
        attendees_str = `${this.attendees[0].name} 외 ${this.attendees.length -
          1}명`;
      }
      return attendees_str;
    },
  },
  watch: {
    search(val) {
      this.searchName = val;
    },
    searchPeople: function(newVal) {
      if (this.attendees.length === 0) {
        this.attendees.push(newVal);
      } else {
        // let attendeesEmail = this.attendees.map(at => at.email);
        // this.attendees = this.attendees.concat(!attendeesEmail.includes(newVal.email) ? newVal : null);
        let isDupUser = this.attendees.find((at) => at.email === newVal.email);
        if (!isDupUser) {
          this.attendees.push(newVal);
        }
      }

      this.isActive = '';
    },
  },
  mounted() {
    this.loading = false;
    this.dialog = true;
    this.$watch(
      () => {
        return this.$refs.userList.lazySearch;
      },
      (val, oldval) => {
        let search = val;
        let searchLength = 4;
        const check = /[ㄱ-ㅎ]|[ㅏ-ㅣ]|[가-힣]/;
        if (check.test(search)) {
          searchLength = 2;
        }
        // console.log(check.test(search), search, searchLength);
        if (search === null || search === '' || search.length < searchLength) {
          // console.log('people clear');
          this.organization = [];
          return;
        }
        this.searchUser(search.trim());
      }
    );
  },
  methods: {
    closeAlert() {
      this.alertDialog.dialog = false;
    },
    initInvitaion() {
      this.attendees = [];
      this.selectedList = [];
      this.isActive = 'none';
    },
    openOrganizationDialog() {
      /* 조직도 */
      this.organizationChartDialog.dialog = true;
    },
    closeOrganizationDialog() {
      this.organizationChartDialog.dialog = false;
    },
    openAddAttendeeDialog() {
      this.addAttendeeDialog.dialog = true;
    },
    closeAddAttendeeDialog() {
      this.addAttendeeDialog.dialog = false;
    },
    openPersonalAddressDialog() {
      /* 개인주소록 */
      this.personalAddressDialog.dialog = true;
    },
    closePersonalAddressDialog(addedList) {
      if (addedList && addedList.length >= 1) {
        let attendeesEmail = this.attendees.map((at) => at.email);
        this.attendees = this.attendees.concat(
          addedList.filter((a) => !attendeesEmail.includes(a.email))
        );
      }
      this.personalAddressDialog.dialog = false;
    },
    openBookmarkCreateDialog() {
      this.bookmarkCreateDialog.dialog = true;
    },
    closeBookmarkCreateDialog() {
      this.bookmarkCreateDialog.dialog = false;
    },
    openExcelUploadDialog() {
      console.log(this.selected);
      this.excelCreateDialog.dialog = true;
    },
    closeExcelUploadDialog(importAttendees) {
      if (importAttendees && importAttendees.length >= 1) {
        let attendeesEmail = this.attendees.map((at) => at.email);
        this.attendees = this.attendees.concat(
          importAttendees.filter((a) => !attendeesEmail.includes(a.email))
        );
      }
      this.excelCreateDialog.dialog = false;
    },
    async additionalInvitation(attendee, notice) {
      // 추가초대
      if (attendee.length === 0) {
        this.alertDialog.dialog = true;
        this.alertDialog.contents = '참석자를 추가해주세요';
      } else {
        let meetingKey = Util.getParam('p');

        let meetingInfo = {
          meetingKey: meetingKey,
          attendees: attendee,
        };
        await this.$http
          .post('/api/v1/meetings/additionalInvitation', meetingInfo)
          .then((response) => {
            if (response.data === 'ok') {
              this.alertDialog.dialog = true;
              this.alertDialog.contents = '초대완료';
              this.initInvitaion();
            }
          })
          .catch((error) => {
            console.log(error);
          });
        console.log(attendee);
        console.log(notice);
      }
    },
    openLayoutDialog() {
      this.layoutDialog.dialog = true;
    },
    closeLayoutDialog() {
      this.layoutDialog.dialog = false;
    },
    closeMeetingInvitation() {
      if (this.attendees.length === 0) {
        this.isActive = 'none';
      } else {
        this.isActive = '';
      }
      if (this.attendeesInfo) {
        if (this.attendeesInfo.length >= 1) {
          this.closeMeetingInvitaionDialog(this.attendees, this.notice);
        } else {
          this.closeMeetingInvitaionDialog();
        }
      } else {
        this.closeMeetingInvitaionDialog();
      }
    },
    remove(item) {
      const index = this.friends.indexOf(item.name);
      if (index >= 0) this.friends.splice(index, 1);
    },
    searchUser: debounce(async function(text) {
      this.people = [];
      await this.$http
        .get('/api/v1/organizations/filtered', {
          params: {
            search: text,
          },
        })
        .then((response) => {
          console.log(response);
          this.organization = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    }, 200),

    deleteAttendee(index) {
      this.attendees.splice(index, 1);
    },
    selectAll() {
      this.checked = [];

      if (this.allSelected) {
        this.attendees.forEach((attendee) => {
          // attendee.checked = false;
        });
        this.selectTitle = '전체선택';
        this.allSelected = false;
      } else {
        if (this.attendees.length === 0) {
          /* 참여자가 0이면 전체선택 안되도록 */
        } else {
          this.attendees.forEach((attendee) => {
            this.checked.push(attendee.email);
          });
          this.selectTitle = '선택해제';
          this.allSelected = true;
        }
      }
    },
    selectDelete(attendee) {
      let attendees = this.attendees;
      console.log(this.attendees);
      for (let i = 0; i < attendees.length; i++) {
        if (attendee.email.toString() === attendees[i].email.toString()) {
          attendees.splice(i, 1);
        }
      }

      if (attendees.length === 0) {
        this.attendees = [];
        this.isActive = 'none';
      }
    },
    selectAllDelete() {
      this.attendees = [];
      this.isActive = 'none';
    },
    select() {
      this.allSelected = false;
      this.selectTitle = '전체선택';
    },
    selectDel() {
      let list = [];
      for (let index = 0; index < this.attendees.length; index++) {
        let select = false;
        for (
          let check_index = 0;
          check_index < this.checked.length;
          check_index++
        ) {
          if (this.checked[check_index] === this.attendees[index].email) {
            select = true;
            break;
          }
        }
        if (!select) {
          list.push(this.attendees[index]);
        }
      }
      this.attendees = list;
    },
    openBookmarkDialog() {
      this.bookmarkDialog.dialog = true;
    },
    closeBookmarkDialog(bookmark) {
      if (bookmark && bookmark.attendees && bookmark.attendees.length >= 1) {
        let attendeesEmail = this.attendees.map((at) => at.email);
        this.attendees = this.attendees.concat(
          bookmark.attendees.filter((a) => !attendeesEmail.includes(a.email))
        );
        this.isActive = '';
      }
      this.bookmarkDialog.dialog = false;
    },
    createSelectedList(selectedList) {
      /* @emit function */
      if (selectedList && selectedList.length >= 1) {
        let attendeesEmail = this.attendees.map((at) => at.email);
        this.attendees = this.attendees.concat(
          selectedList.filter((a) => !attendeesEmail.includes(a.email))
        );
        this.isActive = '';
      }
    },
    closeInvitation() {
      this.initInvitaion();
      this.closeDialog();
    },
    openHelpDialog() {
      this.isHelpActive = '';
    },
    closeHelpDialog() {
      this.isHelpActive = 'none';
    },
  },
};
</script>
<style scoped>
#meetingInvitation .bt_wrap {
  min-width: 780px;
  width: 780px;
  height: 525px;
}
.popup_top {
  padding-left: 0;
  background-color: #efeefd;
}
.popup-title {
  line-height: 77px;
  color: #604af3;
  font-weight: 700;
  font-size: 24px;
  padding-left: 24px;
}
.delete-all-btn {
  width: 80px;
  height: 25px;
  float: right;
  font-size: 10pt;
  background: brown;
  color: white;
  border-radius: 5px;
  margin-top: 10px;
}

.member-area-tb {
  padding-top: 10px;
}

.member-area-tb thead {
  background: gray;
  color: white;
}

.member-area-tb th {
  padding-left: 5px;
  text-align: left;
  border: 1px solid black;
}

.selected-layout-wrap {
  float: left;
  width: 50%;
}
.list_info {
  min-height: 240px;
}
.member-top-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.button_area button {
  background: white;
  border: 1px solid #777777;
  color: #333333;
  border: 1px solid #777777;
  height: 40px;
}
.fix-seat-list-wrap {
  float: left;
  width: 50%;
}

.input_area {
  width: 335px !important;
  padding-top: 0px !important;
  padding-bottom: 0px;
}

.help-bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: black;
  opacity: 0.98;
  z-index: 999;
  overflow-y: auto;
  overflow-x: auto;
  text-align: center;
}
.help-img {
  width: 100%;
  max-width: 670px;
  display: inline-block;
  position: relative;
  top: 7%;
}

.close-img {
  position: fixed;
  top: 10%;
  right: 10%;
  cursor: pointer;
  z-index: 1001;
}

.btnArea {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.invite-btn {
  background-color: #604af3;
  color: white;
  width: 130px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
.close-btn {
  width: 82px;
  height: 48px;
  border-radius: 8px;
  background: #f2f2f2;
  color: #1f2e3d;
  margin: 0 5px;
  font-size: 15px;
}

.delete_all {
  background: none;
}

.user_list li {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

input::placeholder {
  color: #b9b9b9;
  padding-left: 5px;
  font-size: 15px !important;
  font-weight: 100 !important;
  font-family: 'Noto Sans KR', sans-serif !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/additionalInvitation.vue